// Imports
  // React
  import { useEffect, useState } from 'react'
  import { Link } from 'react-router-dom'
  // Firebase
  import { collection, getFirestore, onSnapshot, orderBy, query } from 'firebase/firestore'
  import { updateAllCombosPrices, useAuth } from '../firebase/FirebaseClient'
  // Components
  import ItemCard from './CombosCard'
  // Icons
  import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
  import { faRightFromBracket } from '@fortawesome/free-solid-svg-icons'




// rafce

const CombosList = ( ) => {

  const currentUser = useAuth();
  
  // Get combos

      // useState para que persista
        const [combos, setCombos] = useState([]);
    
      // fragmentos de la config del Firebase
        const db = getFirestore ()
        const combosCollection = collection(db, "combos")
        const q = query(combosCollection, orderBy("category", "desc"))

      // useEffect para que se ejecute sólo al momento de cambiar de categoría    
        useEffect(
          () => 
          onSnapshot(q, (snapshot) =>
            setCombos(snapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }) ) )
          ),
          []
        );
      
      // Listar combos
        function listCombos(){
          // Mostrarlos
          return(
            <div className='item-list-container list'>
              {
                combos.map( i =>
                  <div className="combos-card item-card-resumed" key={i.id}>
                    <ItemCard item={i} />
                  </div>
                )
              }
            </div>
          )
        }


      //Cambiar vista
      const fullView = () => {
        document.getElementsByClassName("item-list-container")[0].classList.remove("list")
        const cards = document.querySelectorAll('.combos-card');
        for(let i=0; i<cards.length; i++){
          cards[i].classList.remove("item-card-resumed")
        }
        document.getElementById("list-view").style.display="block"
        document.getElementById("full-view").style.display="none"
      }
      
      const listView = () => {
        document.getElementsByClassName("item-list-container")[0].classList.add("list")
        const cards = document.querySelectorAll('.combos-card');
        for(let i=0; i<cards.length; i++){
          cards[i].classList.add("item-card-resumed")
        }
        document.getElementById("list-view").style.display="none"
        document.getElementById("full-view").style.display="block"
      }


      // Aumentar todos los precios
      const [percentage, setPercentage] = useState("");
      const increaseAllPrices = () => {
        for(let i=0; i<combos.length; i++){
          updateAllCombosPrices(combos[i].id, combos[i].price, percentage)
        }
      }




// Component
  return (
    <>
      {
        !currentUser
        ?
        (
          <div className='main-admin'>
            <div className='main-admin-buttons'>
              <Link to="/admin" style={{alignSelf:"flex-start"}}>
                <FontAwesomeIcon icon={ faRightFromBracket } flip="horizontal" />
              </Link>
            </div>
            <p>
              Por favor inicie sesión para continuar
            </p>
          </div>
        )
        :
        <div className='main-admin-items'>
          <div className='main-admin-fixed'>
            <div className='main-admin-buttons'>
              <Link to="/admin"><FontAwesomeIcon icon={ faRightFromBracket } flip="horizontal" /></Link>
              <Link className="admin-item-button" to="/admin/combos/nuevo">Crear Combo</Link>
              <button id="list-view" style={{display:"none"}} className="admin-item-button" onClick={listView}>Ver Lista</button>
              <button id="full-view" className="admin-item-button" onClick={fullView}>Vista Completa</button>
              <Link className="admin-item-button" to="/admin/productos">Ir a Productos</Link>
              <input className="admin-item-text-box"
                      name="percentage"
                      type="number"
                      step="0.01"
                      onWheel={e => e.target.blur()}
                      placeholder="Porcentaje..."
                      onChange={ (e) => setPercentage(e.target.value) } />
              <button className="admin-item-button" onClick={increaseAllPrices}>Aumentar</button>
            </div>
          </div>
          {
            combos.length ?
            (
                listCombos()
            ) :
            <>
              <div className="loading">
                <span></span>
              </div>
            </>
          }
        </div>
      }
    </>
  )
}

export default CombosList

